import ApiService from "../../../../ApiService";

const SummaryService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/management/summary/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
    LoadUserHomeworkStatistics: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/management/summary/loaduserhomeworkstatistics", vo, successCallback, failureCallback);
    },
    returnUserHomework: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/management/summary/returnuserhomework", vo, successCallback, failureCallback);
    },
    fixHomework: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/management/summary/fixhomework", { searchVO }, successCallback, failureCallback);
    },
    fixHomeworkZip: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/homework/management/summary/fixhomeworkzip", { searchVO }, successCallback, failureCallback);
    }
};

export default SummaryService;
